import { RefObject, useEffect, useState } from "react";

export const useElementWidth = (
  ref: RefObject<HTMLElement>,
  threshold: number
): boolean => {
  const [isBelowThreshold, setIsBelowThreshold] = useState(false);

  useEffect(() => {
    if (!ref.current) {
      return () => {
        // cleanup, this does nothing
      };
    }

    const observer = new ResizeObserver(([entry]) => {
      if (entry.contentRect.width < threshold) {
        setIsBelowThreshold(true);
      } else {
        setIsBelowThreshold(false);
      }
    });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref, threshold]);

  return isBelowThreshold;
};
